import { getAll as _getAll, patchAsync as _patchAsync } from "../../api";

const BASE_URL = "/settings/configurations";

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError });
}

export async function patchAllAsync(data) {
    return _patchAsync({ url: `${BASE_URL}/all`, data });
}
